import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Leva } from "leva";
import { getViewportDevice } from "./utils/viewport";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Leva
      hidden={process.env.NODE_ENV !== "development"}
      collapsed
      titleBar={{
        title: "Debug Pannel",
        position: { x: getViewportDevice() === "mobile" ? -60 : -200, y: 0 },
      }}
    />
    <App />
  </React.StrictMode>
);

reportWebVitals();
